// removed by extract-text-webpack-plugin
module.exports = {"accordionSection":"AccordionSection__accordionSection___1WKdL","isTotal":"AccordionSection__isTotal___2mV-y","title":"AccordionSection__title___1fRQ0","isTotalDouble":"AccordionSection__isTotalDouble___3j-A_","accordionContent":"AccordionSection__accordionContent___Hmnqu","notExpandable":"AccordionSection__notExpandable___30FAI","open":"AccordionSection__open___9LfGl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/AccordionSection/AccordionSection.scss
// module id = 382
// module chunks = 0